<template>
  <div class="container-fluid px-0">
    <div class="row mb-4 g-2">
      <!-- Status Filter -->
      <div class="col-6 col-md-2 col-lg-4">
        <select 
          class="form-select form-select-sm" 
          v-model="statusFilter" 
          @change="handleStatusFilter"
        >
          <option value="">{{ $t('subjects.allStatuses') }}</option>
          <option value="active">{{ $t('subjects.active') }}</option>
          <option value="inactive">{{ $t('subjects.inactive') }}</option>
        </select>
      </div>
      
      <!-- Reset Button (Desktop) -->
      <div class="col-md-1 d-none d-md-block">
        <button 
          class="btn btn-outline-secondary btn-sm w-100" 
          @click="resetFilters"
          :title="$t('subjects.reset')"
        >
          <i class="fas fa-filter-circle-xmark"></i>
        </button>
      </div>
            
      <!-- Reset Button (Mobile) -->
      <div class="col-6 d-md-none">
        <button class="btn btn-outline-secondary btn-sm w-100" @click="resetFilters">
          <i class="fas fa-filter-circle-xmark"></i> {{ $t('subjects.reset') }}
        </button>
      </div>
      
      <!-- Search Input -->
      <div class="col-12 col-md-3 col-lg-7 position-relative">
        <input
          type="text"
          class="form-control form-control-sm ps-5"
          :placeholder="$t('subjects.searchPlaceholder')"
          v-model="searchTerm"
          @input="handleSearch"
          style="padding-right: 12px"
        />
        <span class="position-absolute start-0 top-50 translate-middle-y ps-3">
          <i class="fas fa-search"></i>
        </span>
      </div>

    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits } from 'vue';
import { debounce } from 'lodash';

const searchTerm = ref('');
const statusFilter = ref('');

const emit = defineEmits(['search', 'status', 'add']);

const handleSearch = debounce(() => {
  emit('search', searchTerm.value);
}, 300);

const handleStatusFilter = () => {
  emit('status', statusFilter.value);
};

const resetFilters = () => {
  searchTerm.value = '';
  statusFilter.value = '';
  emit('search', '');
  emit('status', '');
};
</script>
